import { render } from "./ClientsSection.vue?vue&type=template&id=6d456506&scoped=true"
import script from "./ClientsSection.vue?vue&type=script&lang=js"
export * from "./ClientsSection.vue?vue&type=script&lang=js"

import "./ClientsSection.vue?vue&type=style&index=0&id=6d456506&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d456506"]])

export default __exports__